/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JiraDataCenterProject extends models.JiraProject {
    getFixupPrototypeFunction() { return JiraDataCenterProject.fixupPrototype; }

    static newInstance(model: Partial<JiraDataCenterProject>): JiraDataCenterProject {
        let obj = Object.assign(new JiraDataCenterProject(), model);
        JiraDataCenterProject.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JiraDataCenterProject>): JiraDataCenterProject {
        if (!model) return null;
        return JiraDataCenterProject.newInstance(<JiraDataCenterProject> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JiraDataCenterProject) {
        if (!obj) return;

        models.JiraDataCenterProject.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JiraDataCenterProject): boolean {
        if (models.JiraProject.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, JiraDataCenterProject.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.avatarUrls) {
            models.JiraDataCenterAvatarUrl.fixupPrototype(this.avatarUrls);
        }
    }

    /**
     * Expansion attribute of the project
     */
    expand: string;

    /**
     * Avatar Urls for Integrated Tools Projects
     */
    avatarUrls: models.JiraDataCenterAvatarUrl;

}
